<template>
  <AppPage class="catalog-page">
    <AppHeader
        :title="title"
        :left-action="onButtonBack"
        :right-action="rightAction"
    />
    <AppSection v-if="!category">
      <CategoryList :categories="catalog_categories" @CategorySelected="onCategorySelected" />
    </AppSection>

    <AppSection v-if="category">
      <ProductList :products="products" @ProductSelected="onProductSelected" />
    </AppSection>
    <div class="add-product-container" v-if="category && product">
      <OrderAddProductModal
        :product="product"
        :formats="product_formats"
        :extras="product_extras"
        @addProduct="onAddProduct"
        @closeAddModal="onCloseAddModal"
      />
    </div>
  </AppPage>
</template>
<script>
import { catalogoRef, categoriesRef, productsRef, usersRef } from '../firebase'
import CategoryList from '../components/Categories/CategoryList'
import ProductList from '../components/Products/ProductsList'
import OrderAddProduct from '../components/Order/OrderAddProduct'
import OrderAddProductModal from '../components/Order/OrderAddProductModal/OrderAddProductModal'

export default {
  components: {
    OrderAddProduct,
    OrderAddProductModal,
    CategoryList,
    ProductList
  },
  data() {
    return {
      products: [],
      category: null,
      product: null,
      product_formats: [],
      product_extras: []
    }
  },
  mounted() {
    const user = this.$store.getters.user
    if (!user) this.$router.push('/')
    else {
      this.$store.commit('isLoading', true)
      catalogoRef.once('value', snap => {
        this.$store.commit('setCatalog', snap.val())
        const catalog = this.$store.state.catalog

        categoriesRef.once('value', snap => {
          const categorias = snap.val()
          const favoritos = catalog.FAVORITOS
          const tmp_favoritos = favoritos.map((f, i) =>
            Object.assign({}, favoritos[i], categorias[f.CODFAVORITO])
          )
          this.$store.commit('setCatalogCategories', tmp_favoritos)

          productsRef.once('value', snap => {
            const productos = snap.val()
            const articulos = catalog.ARTICULOS
            const tmp_Articulos = articulos.map((p, i) =>
              Object.assign({}, articulos[i], productos[p.CODARTICULO])
            )

            // console.log(tmp_Articulos)
            this.$store.commit('setCatalogProducts', tmp_Articulos)
            this.$store.commit('isLoading', false)
          })
        })
      })
    }
  },
  computed: {
    title() {
      if (!this.category) return 'NUESTRA CARTA'
      if (this.category && !this.product) return this.category.DESCRIPCION
      if (this.category && this.product) return this.product.DESCRIPCION
    },
    catalog_categories() {
      return this.$store.state.catalog_categories
    },
    catalog_products() {
      return this.$store.state.catalog_products
    }
  },
  methods: {
    onCloseAddModal() {
      this.product = null
      this.product_formats = null
      this.product_extras = null
    },
    rightAction() {
      this.onOpenOrder()
    },
    onAddProduct(product) {
      if (product.PVP > 0 || product.TOTAL > 0) {
        const uid = this.$store.state.profile.user.uid
        usersRef
          .child(uid)
          .child('order')
          .push({ ...product })
          .then(() => {
            if (this.category && this.product) this.product = null
            const precio = product.TOTAL > 0 ? product.TOTAL : product.PVP
            this.$toasted.success(
              `${product.DESCRIPCION.toUpperCase()} ... ${Number(
                precio
              ).toFixed(2)}€`,
              { fullWidth: true, icon: { name: 'cart-plus' } }
            )
          })
      } else {
        this.$toasted.error(`NO SE PUEDE AÑADIR UN PRODUCTO CON PRECIO 0.00€`, {
          fullWidth: true,
          icon: { name: 'money-bill-alt' }
        })
      }
    },
    onCategorySelected(category) {
      this.products = []
      category.ARTICULOS.forEach(c => {
        const articulo = this.catalog_products.find(p => p.CODARTICULO === c)
        this.products.push(articulo)
      })
      this.category = category
    },
    onProductSelected(product) {
      if (
        (product.FORMATOS && product.FORMATOS.length > 0) ||
        (product.MODIFICADORES && product.MODIFICADORES.length > 0)
      ) {
        const catalog_modificadores = this.$store.getters.catalog_modificadores

        // FORMATOS
        this.product_formats = []
        if (product.FORMATOS)
          product.FORMATOS.forEach(f => {
            const formato = this.$store.state.catalog.FORMATOS.find(
              cf => cf.CODFORMATO === f.CODFORMATO
            )
            this.product_formats.push(formato)
          })
        // MODIFICADORES
        this.product_extras = []
        if (product.MODIFICADORES) {
          if (product.GRUPOSEXTRAS) {
            const grupos = Object.keys(product.GRUPOSEXTRAS)
            let extras = []
            grupos.forEach(k => {
              let grupo = product.GRUPOSEXTRAS[k]
              grupo.CODMODIFICADOR = k
              grupo.DESCRIPCION = grupo.description
              grupo.LIMITE = grupo.max || 0
              grupo.MINIMO = grupo.min || 0
              extras.push(grupo)
            })
            this.product_extras = extras
          } else {
            product.MODIFICADORES.forEach(m => {
              const modificador = Object.assign(
                {},
                catalog_modificadores.find(
                  cm =>
                    cm.CODMODIFICADOR === m ||
                    cm.CODMODIFICADOR === m.CODMODIFICADOR
                )
              )
              modificador.CODOPCIONES = modificador.OPCIONES
              modificador.OPCIONES = []
              modificador.CODOPCIONES.forEach(o => {
                const opcion = this.$store.getters.catalog_opciones.find(
                  co => co.CODARTICULO === o
                )
                const articulo = this.catalog_products.find(
                  p => p.CODARTICULO === o
                )
                const opcionArticulo = Object.assign({}, articulo, opcion)
                modificador.OPCIONES.push(opcionArticulo)
              })
              modificador.DESCRIPCION = modificador.DESCRIPCION.replace(
                product.DESCRIPCION,
                ''
              )
              this.product_extras.push(modificador)
            })
          }
        }
      }

      this.product = product
    },
    onButtonBack() {
      if (this.product) this.product = null
      else if (this.category) this.category = null
      else this.$router.push('/')
    },
    onOpenOrder() {
      this.$router.push('/order')
    }
  }
}
</script>

<style lang="scss">
.catalog-page {
  display: flex;
  flex-direction: column;

  .add-product-container {
    padding: 1rem;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/Catalog.vue